import { genericCRUDService } from '../../helpers/api';

export const { findAll, downloadAll } = genericCRUDService(
  '/validators',
  '/api/v1/traveler-validations',
);
